import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode'


@Injectable({
  providedIn: 'root',
})
export class AccessAuthService {
  isAdmin = new BehaviorSubject<boolean>(false);
  user_info_obj_BehaviorSubject = new BehaviorSubject<{
    "role": string,
    "name": string,
    "displayname": string
  }>(null);

  constructor(private router: Router) {
    if (localStorage.getItem('accessToken')) {

      let user_info_obj: any = jwt_decode(localStorage.getItem('accessToken'));
      let adminAuthorization: boolean = user_info_obj.role === "admin" ? true : false;
      this.isAdmin.next(adminAuthorization);
      this.user_info_obj_BehaviorSubject.next(user_info_obj)
    }
  }

}
